import _ from 'lodash';
import { Autocomplete } from '@material-ui/lab';
import React, { ChangeEvent, ChangeEventHandler, ReactNode, useMemo } from 'react';
import { CSSProperties } from 'styled-components';
import './styles.scss';
import DefaultTextField from '../DefaultTextField';
import { TextField } from '@material-ui/core';

type Option = {
  value: string;
  label?: string;
};

type LegacyProps<T> = {
  options: (T & Option)[];
  label?: string;
  placeholder?: string;
  style?: CSSProperties;
  input?: { value: string; onChange: (value: string) => void };
  id?: string;
  onUpdateInput?: (value: string) => void;
  onChange?: (value: string) => void;
  allowClear?: boolean;
  clearable?: boolean;
  popOut?: boolean;
  renderOption?: (option: T & Option) => ReactNode;
  disableEdit?: boolean;
};

const NewDefaultAutoComplete = function <T>(props: LegacyProps<T>) {
  const { options } = props;

  const value = (props.input || {}).value || '';

  return (
    <Autocomplete
      disabled={props.disableEdit}
      inputValue={value}
      id={props.id}
      options={options}
      getOptionLabel={(option) => option.label ?? option.value}
      renderOption={props.renderOption}
      renderInput={(params) => (
        <DefaultTextField
          {...params}
          inputProps={params.InputProps}
          htmlInputProps={params.inputProps}
          label={props.label}
        />
      )}
      freeSolo
      openOnFocus
      filterOptions={(it) => it}
      onChange={(event, option) => {
        if (!event || !event.target || !option) {
          return;
        }
        let value = (option as Option).value;
        if (props.input) props.input.onChange(value);
        else props.onChange?.(value);
      }}
      onInputChange={(event, value) => {
        if (!event || !event.target) {
          return;
        }
        if (props.onUpdateInput) {
          props.onUpdateInput?.(value);
        } else if (props.input) props.input.onChange(value);
        else props.onChange?.(value);
      }}
    />
  );
};

export default NewDefaultAutoComplete;
